import Firebase from 'firebase/app';
import 'firebase/auth';
import '@firebase/firestore';
import 'firebase/storage';

export const API_KEY = 'AIzaSyDj6hgq_dIY7-wxbhAEt88c_xtTiwowISs';
export const AUTH_DOMAIN = 'mca-dev-3954c.firebaseapp.com';
export const DATABASE_URL = 'https://mca-dev-3954c.firebaseio.com';
export const PROJECT_ID = 'mca-dev-3954c';
export const STORAGE_BUCKET = 'mca-dev-3954c.appspot.com';
export const MESSAGING_SENDER_ID = '1082834851928';
export const APP_ID = '1:1082834851928:web:2fcc2821c93fe4fcc8d22d';

export interface FirebaseConfig {
  apiKey: string;
  authDomain?: string;
  databaseUrl?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
  measurementId?: string;
}

const swaparoundConfig: FirebaseConfig = {
  apiKey: 'AIzaSyDh-MqoMZTQ0CFQc-FlvVq6suWOGAn9nuw',
  authDomain: 'swaparound-dev.firebaseapp.com',
  databaseUrl: 'https://swaparound-dev.firebaseio.com',
  projectId: 'swaparound-dev',
  storageBucket: 'swaparound-dev.appspot.com',
  messagingSenderId: '33907389364',
  appId: '1:33907389364:web:5ebf3e5f1780f44d93b8e1',
  measurementId: 'G-6DXTEKBZGH',
};

const SwapAroundProdConfig = {
  apiKey: 'AIzaSyDgDZ-WsSFCuF3ph4XVF9erIMXBwarNiGY',
  authDomain: 'swaparound-39afc.firebaseapp.com',
  databaseURL: 'https://swaparound-39afc.firebaseio.com',
  projectId: 'swaparound-39afc',
  storageBucket: 'swaparound-39afc.appspot.com',
  messagingSenderId: '635024556414',
  appId: '1:635024556414:web:405b159832735b504bf32f',
  measurementId: 'G-BMNRS88YE7',
};

export const MyCookAroundFirebase: Firebase.app.App = Firebase.initializeApp(
  // swaparoundConfig
  SwapAroundProdConfig
);

export const firestore = MyCookAroundFirebase.firestore();
